
export default function BlogSection() {
  const blogPosts = [
    {
      title: "Why Blue Team's Truck-Mounted Steam Cleaning is Superior to Portable Units",
      excerpt: "Discover why Blue Team's powerful truck-mounted hot water extraction system delivers deeper cleaning results than portable units. Our professional-grade equipment reaches temperatures up to 240°F and provides superior suction power for thorough dirt and allergen removal from your Escondido home's carpets...",
      image: "https://public.readdy.ai/ai/img_res/3c146b8aab93fa52043bf720a2636d8f.jpg",
      date: "January 15th, 2025",
      category: "Professional Equipment",
      link: "#"
    },
    {
      title: "Pet Stain and Odor Removal: Blue Team's Proven Process for San Diego Homes",
      excerpt: "Pet accidents happen, but permanent odors don't have to. Learn about Blue Team's specialized pet stain and odor removal process that eliminates urine odors at the molecular level. Our eco-friendly treatments are safe for your family and pets while completely removing stubborn stains and smells from carpets and upholstery...",
      image: "https://readdy.ai/api/search-image?query=Professional%20carpet%20cleaning%20technician%20treating%20pet%20stains%20on%20carpet%20with%20eco-friendly%20cleaning%20solution%2C%20family%20dog%20nearby%2C%20clean%20modern%20home%20interior%2C%20safe%20cleaning%20process&width=400&height=250&seq=2&orientation=landscape",
      date: "January 10th, 2025",
      category: "Pet Stain Removal",
      link: "#"
    },
    {
      title: "How Often Should You Clean Your Carpets? Blue Team's Expert Recommendations",
      excerpt: "As Escondido's trusted carpet cleaning experts since 1994, Blue Team recommends professional cleaning every 12-18 months for most homes. However, high-traffic areas, homes with pets, or family members with allergies may benefit from more frequent cleaning. Learn our professional recommendations for maintaining healthy, beautiful carpets...",
      image: "https://readdy.ai/api/search-image?query=Clean%20beautiful%20carpet%20in%20modern%20living%20room%20showing%20before%20and%20after%20professional%20cleaning%20results%2C%20family%20home%20interior%2C%20fresh%20clean%20appearance%2C%20natural%20lighting&width=400&height=250&seq=3&orientation=landscape",
      date: "January 5th, 2025",
      category: "Maintenance Tips",
      link: "#"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Blue Team Cleaning Tips & Insights</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-video overflow-hidden">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <span>By Blue Team Home Services</span>
                  <span className="mx-2">|</span>
                  <span>{post.date}</span>
                  <span className="mx-2">|</span>
                  <span className="text-teal-600">{post.category}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
                  <a href={post.link} className="hover:text-teal-600 transition-colors cursor-pointer">
                    {post.title}
                  </a>
                </h3>
                
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{post.excerpt}</p>
                
                <a 
                  href={post.link} 
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium text-sm cursor-pointer"
                >
                  Read More
                  <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="#" 
            className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer inline-block"
          >
            Load More Posts
          </a>
        </div>

        {/* Maintenance Tips */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Blue Team Carpet Care Tips</h3>
            <div className="space-y-4 text-gray-700">
              <p>
                Professional carpet cleaning is essential to maintain your investment and ensure a healthy home environment for your family.
              </p>
              <p>
                Blue Team's truck-mounted hot water extraction system removes deep-seated dirt, allergens, and bacteria that regular vacuuming can't reach. Our process extends carpet life and improves indoor air quality throughout your Escondido home.
              </p>
              <p>
                Many San Diego County families notice improved air quality and reduced allergy symptoms after our professional cleaning removes dust mites, pet dander, and other allergens trapped in carpet fibers.
              </p>
              <p className="font-semibold">
                For optimal carpet health and appearance, Blue Team recommends professional cleaning every 12-18 months for most homes, or every 6-12 months for high-traffic areas and homes with pets or allergies.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Upholstery Care by Blue Team</h3>
            <div className="space-y-4 text-gray-700">
              <p>
                Your furniture represents a significant investment that deserves professional care to maintain its beauty, comfort, and value.
              </p>
              <p>
                Blue Team's specialized upholstery cleaning process safely removes stains, odors, and allergens from sofas, sectionals, dining chairs, and mattresses without damaging delicate fabrics or leaving residue.
              </p>
              <p>
                Our trained technicians use fabric-appropriate cleaning methods and eco-friendly solutions that are safe for your family and pets while delivering exceptional results that restore your furniture's original appearance.
              </p>
              <p className="font-semibold">
                Regular professional upholstery cleaning every 12-24 months protects your investment, extends furniture life, and maintains a healthier home environment for your San Diego County family.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
